import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { ReporteTotalSaldoCapitalAdministradoComponent } from './ReporteTotalSaldoCapitalAdministrado.component';


import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';





const routes = [
    {
        path     : 'ReporteTotalSaldoCapitalAdministrado',
        component: ReporteTotalSaldoCapitalAdministradoComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ReporteTotalSaldoCapitalAdministrado',
          nombreFormulario : 'ReporteTotalSaldoCapitalAdministrado'
        } 
    }
];

@NgModule({
    declarations: [
        ReporteTotalSaldoCapitalAdministradoComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        ReporteTotalSaldoCapitalAdministradoComponent
    ]
})

export class ReporteTotalSaldoCapitalAdministradoModule
{
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ReporteTotalSaldoCapitalAdministrado/ReporteTotalSaldoCapitalAdministrado.module.ts